import { render, staticRenderFns } from "./jizhang.vue?vue&type=template&id=057295ae&scoped=true"
import script from "./jizhang.vue?vue&type=script&lang=js"
export * from "./jizhang.vue?vue&type=script&lang=js"
import style0 from "./jizhang.vue?vue&type=style&index=0&id=057295ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057295ae",
  null
  
)

export default component.exports